export default "__VITE_ASSET__Da87Mv0Q__"